import React, { Component } from 'react';
// import headshot from './../images/bw-headshot.jpg';
import headshot from './../images/hands-vertical-bw-full.jpg';
import './App.css';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      smallScreen: window.innerWidth < 1025
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  updateDimensions() {
    this.setState({smallScreen: window.innerWidth < 1025});
  }

  render() {
    return (
      <div className={this.state.smallScreen ? "outer-container-small": "outer-container"}>
        <div className={this.state.smallScreen ? "left-container-small": "left-container"}>
          <div className="left-container-image-wrapper">
            <img src={headshot} className="left-container-image" />
          </div>
        </div>
        <div className={this.state.smallScreen ? "right-container-small": "right-container"}>
          <h1 className={"name-text " + (this.state.smallScreen ? "name-text-small" : "")}>Kelley Rose</h1>
          <p className="right-container-text">I'm in the process of revamping my site. But a little about me while you're here... I’m currently working as a Web and Mobile Developer at Digital Scientists, where I get to collaborate with designers and developers alike to build beautiful and highly functional web and mobile applications.</p>
          <p className="right-container-text">I have a wide range of experience from marketing, to design, to account management, to development using front and and back end technologies (but my favorite is JavaScript of course - it does all the things). If I'm not designing or developing something, you will likely find me practicing yoga or climbing.</p>
          <p className="right-container-text">I'm alway interested in networking, so feel free to reach out and connect.</p>
          <p className="right-container-text">
            <a className="link-text" href="mailto:kelley@kelleyrose.co">kelley@kelleyrose.co</a>

          </p>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js